"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvitedUserFromCredentials = void 0;
const toolbox_1 = require("@streem/toolbox");
const logger_1 = require("./logger");
const api_1 = require("@streem/api");
function getInvitedUserFromCredentials(credentials) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { invitation } = yield api_1.StreemAPI.default.getCurrentInvitation();
            (0, toolbox_1.invariant)(invitation, "Received successful GetCurrentInvitationResponse without an 'invitation'");
            logger_1.logger.setContextValue('inviteId', invitation.invitationSid);
            return {
                id: credentials.streem_user_id,
                companyId: credentials.streem_company_id,
                invitation,
                exp: credentials.expires_in,
            };
        }
        catch (error) {
            logger_1.logger.error({
                msg: 'Error getting current invitation',
                error: error,
            });
            throw error;
        }
    });
}
exports.getInvitedUserFromCredentials = getInvitedUserFromCredentials;
//# sourceMappingURL=invite_user.js.map